<div class="category-selector">
    <div class="category-selector--back-to-branch-button" (click)="handleBackToBranchClick($event)">
        <img *ngIf="backToBranchClick && backToBranchClick.observers.length" alt="Volver"
            src="./assets/images/arrow-menu_down.png" class="back-to-branch-button--icon">
        <img [src]="backToBranchIconSrc" [alt]="backToBranchLabel" class="branch-icon">
        <span>{{backToBranchLabel}}</span>
    </div>
    <div class="category-selector--list">
        <sc-list-set (onClick)="handleOnClick($event)" [rowData]="rowData" [title]="title"
            [runAnimation]="runAnimation">
            <ng-template let-row="row" let-index="index">
                <div id="{{row.id}}">
                    <div class="list-row--icons">
                        <sc-icon [icon]="row.fontIcon" size="1_75"></sc-icon>
                    </div>
                    <span class="list-row--title">{{row.text}}</span>
                </div>
            </ng-template>
        </sc-list-set>
    </div>
</div>